module.exports = __webpack_public_path__ + "static/img/joseBottomRight.24d7dbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/romboTeam/Jose/joseBottomRight.png
// module id = 560
// module chunks = 1